import {
    GET_PROPERTY_MEMBERS,
    GET_PROPERTY_MEMBERS_SUCCESS,
    GET_PROPERTY_MEMBERS_FAILURE,
    GET_INVITED_PROPERTY_MEMBERS_SUCCESS,
    GET_INVITED_PROPERTY_MEMBERS_FAILURE,
    GET_MEMBER_KEYS,
    GET_MEMBER_KEYS_SUCCESS,
    GET_MEMBER_KEYS_FAILURE,
    RESET_PROPERTY_MEMBERS,
    RESET_MEMBER_KEYS,
    GET_PROPERTY_MEMBERS_CODES,
    GET_PROPERTY_MEMBERS_CODES_SUCCESS,
    GET_PROPERTY_MEMBERS_CODES_FAILURE,
    GET_VG_PROPERTY_BY_ID,
    GET_VG_PROPERTY_BY_ID_SUCCESS,
    GET_VG_PROPERTY_BY_ID_FAILURE
} from './types';

export const getPropertyMembers = id => {
    return {
        type: GET_PROPERTY_MEMBERS,
        payload: id
    };
};

export const getPropertyMembersSuccess = members => {
    return {
        type: GET_PROPERTY_MEMBERS_SUCCESS,
        payload: members
    };
};

export const getPropertyMembersFailure = error => {
    return {
        type: GET_PROPERTY_MEMBERS_FAILURE,
        payload: error
    };
};

export const getInvitedPropertyMembersSuccess = members => {
    return {
        type: GET_INVITED_PROPERTY_MEMBERS_SUCCESS,
        payload: members
    };
};

export const getInvitedPropertyMembersFailure = error => {
    return {
        type: GET_INVITED_PROPERTY_MEMBERS_FAILURE,
        payload: error
    };
};

export const getMemberKeys = data => {
    return {
        type: GET_MEMBER_KEYS,
        payload: data
    };
};

export const getMemberKeysSuccess = keys => {
    return {
        type: GET_MEMBER_KEYS_SUCCESS,
        payload: keys
    };
};

export const getMemberKeysFailure = error => {
    return {
        type: GET_MEMBER_KEYS_FAILURE,
        payload: error
    };
};

export const resetPropertyMembers = () => {
    return {
        type: RESET_PROPERTY_MEMBERS
    };
};

export const resetMemberKeys = () => {
    return {
        type: RESET_MEMBER_KEYS
    };
};

export const getPropertyMembersCodes = id => {
    return {
        type: GET_PROPERTY_MEMBERS_CODES,
        payload: id
    };
};

export const getPropertyMembersCodesSuccess = codes => {
    return {
        type: GET_PROPERTY_MEMBERS_CODES_SUCCESS,
        payload: codes
    };
};

export const getPropertyMembersCodesFailure = error => {
    return {
        type: GET_PROPERTY_MEMBERS_CODES_FAILURE,
        payload: error
    };
};

export const getVgPropertyById = id => {
    return {
        type: GET_VG_PROPERTY_BY_ID,
        payload: id
    };
};

export const getVgPropertyByIdSuccess = property => {
    return {
        type: GET_VG_PROPERTY_BY_ID_SUCCESS,
        payload: property
    };
};

export const getVgPropertyByIdFailure = error => {
    return {
        type: GET_VG_PROPERTY_BY_ID_FAILURE,
        payload: error
    };
};
